import React from "react";

import { ApplyStep } from "features/program-applications/utils";
import type { PageServerParams as CohortPageParams } from "pages/programs/[programSlug]/cohorts/[cohortSlug]";
import type { PageServerParams as StepPageParams } from "pages/programs/[programSlug]/cohorts/[cohortSlug]/steps/[stepSlug]";

import { ApplicationTimelineItem } from "./application-timeline-item";

const mobileLeftOffset = (applySteps: ApplyStep[], currentApplicationStep: ApplyStep): number => {
  const leftOffsets: number[] = [0, -48, -96];
  const index = applySteps.findIndex((as) => as.slug === currentApplicationStep.slug);
  if (typeof window !== "undefined" && window.innerWidth < 640) {
    return leftOffsets[index] || 0;
  }
  return 0;
};

export type ApplicationTimelineProps = CohortPageParams & Pick<StepPageParams, "applyStep"> & { inverse?: boolean };
export const ApplicationTimeline: React.FC<React.PropsWithChildren<Readonly<ApplicationTimelineProps>>> = ({
  applySteps,
  applyStep,
  inverse = false,
  cohort,
  program,
}) => (
  <div
    className="relative mx-auto transition-transform w-96 md:w-128"
    style={{
      transform: `translate(${mobileLeftOffset(applySteps, applyStep)}px, 0px)`,
    }}
  >
    <div className="absolute left-0 right-0 z-10 w-64 mx-auto border-b border-gray-300 md:w-full md:max-w-sm top-4"></div>
    <div className="flex justify-between">
      {(applySteps as ApplyStep[]).map((applyStepIterator, idx) => (
        <ApplicationTimelineItem
          key={`timeline-${applyStepIterator.slug}`}
          index={idx}
          applyStepIterator={applyStepIterator}
          applyStep={applyStep}
          inverse={inverse}
          cohort={cohort}
          program={program}
        />
      ))}
    </div>
  </div>
);
